<template>
    <div>
        <span>
            <router-link :to="{name:'BoxesHome'}" tag="a">
                <i class="fas fa-arrow-left"></i>
            </router-link>
            <span class="title-section">{{ currentBox && getCurrentTrackType }}</span>
            <span class="title-separator">|</span>
            <span>
                <span v-if="isLoadingBox">...</span>
                <span v-else-if="isLoadingBox != null">
                    <span v-if="isLoadingBox">Loading Box ...</span>
                    <span v-else-if="currentBox!=null">{{ currentBox.name }}</span>
                </span>
            </span>
        </span>

    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapState, mapActions } from 'vuex'
    import store from '@/store/index.js'
    import Bootstrap from 'bootstrap-vue'
    import Translations from '@/store/translations';
    import EventBus from '@/eventbus';

    Vue.use(Bootstrap);

    export default {
        name: "BoxHeader",
        store,
        created() {
        },
        components: {
        },
        computed: {
            Translations: () => Translations,
            ...mapState({
                isLoadingBox: state => state.loadingStates.isLoadingBox,
                currentBox: state => state.currentBox,
                trackList: state => state.Boxes.trackList
            }),
            getCurrentTrackType() {
                return this.currentBox && this.currentBox.trackType === 'UNDEFINED' ? 'PLAYLIST' : this.currentBox.trackType
            },
        },
    }
</script>

<style lang="scss" scoped>
    .title-section{
        margin-left: 15px !important;
    }
    .little-badge{
        margin-left: 10px !important;
        padding: 3px !important;
        border-radius: 5px;
        background: #d2d2d1;
        color: #ffffff;
        font-size: 12px !important;
    }
</style>
